export default {
  all_conglomerates: 'All Conglomerates',
  create: 'Create Conglomerate',
  edit: 'Edit Conglomerate',
  conglomerate_name: 'Conglomerate Name',
  country: 'Country',
  status: 'Status',
  active: 'Active',
  inactive: 'Inactive',
  status_created: 'Current',
  status_inactive: 'Historical',
  total_schools: 'Total Schools',
  total_licenses: 'Total Licenses',
  actions: 'Actions',

  associated_schools: 'Associated campuses',
  school_name: 'School name',
  unlink_school: 'Unlink campus',
  unlink_confirmation: 'Unlink this campus from the conglomerate?',
  unlink_success: 'Campus unlinked',

  agreement: 'Agreement',
  current_agreement: 'Current agreement',
  agreement_history: 'Agreement history',
  agreement_name: 'Agreement name',
  agreement_type: 'Type',
  agreement_total_licenses: 'Total licenses',
  agreement_dates: 'Dates',
  create_agreement: 'Create agreement',
  edit_agreement: 'Edit agreement',
  edit_agreement_hint:
    'If you change both dates or the agreement type, a new record will be created and the current one will become historical.',

  start_date: 'Start date',
  end_date: 'End date',
  licenses: 'licenses',
  no_name: 'No name',
  no_agreements: 'No agreements registered',
  no_agreements_description: 'Create an agreement to define licenses and validity dates.',
  expired: 'Expired',

  type_demo: 'Demo',
  type_trial: 'Trial',
  type_client: 'Client',

  save_success: 'Changes saved',
  create_success: 'Conglomerate created',
  error_loading: 'Error loading conglomerates',
  error_saving: 'Error saving',
  error_validation: 'Check required fields',
};
